<div class="flxClmn bs-enabled">
	<div class="page-title-container flxClmn-center">
		<div class="page-title-inner-container">
			<span class="page-title">Integrations</span>
		</div>
		<div class="page-subtitle-container">
			<span class="page-subtitle">Connect {{gs.corpname}} with third-party services and providers</span>
		</div>
	</div>

	<div class="page-inner-content-holder flxClmn">

		<div class="flxRow-center" *ngIf="!isLoaded">
			<loader height="100" width="100" style="opacity: 0.8;"></loader>
		</div>

		<!--Tabs-->
		<!-- CC: taken from collaboration-overview.component.html -> md-tabs -->
		<div class="md-tabs mb-3" [ngStyle]="{'--md-tabs-width': tabWidth + 'px'}" *ngIf="isLoaded">
			<ng-container *ngFor="let tab of tabs | keyvalue: gs.returnZero">
				<div [ngClass]="{'selected' : activeTab === tab.value}" (click)="setActiveTab(tab.value);">
					<input type="radio" name="tabs" id="{{tab.key}}Toggle" [checked]="activeTab === tab.value">
					<label for="{{tab.key}}Toggle">
						<span>{{tab.value}}</span>
					</label>
				</div>
			</ng-container>

			<div class="slide" [ngStyle]="{'left' : tabWidth * activeTabIndex + 'px' || 0}"></div>
		</div>

		<!--Services tab-->
		<div class="list-group list-group-flush settings-list-container" *ngIf="isLoaded && activeTab === tabs.general">
			<div class="list-group-item settings-list-item">
				<div class="flex-column gap-3" style="max-width: 300px;">
					<b>Email Infrastructure</b>
					<span style="font-size: 0.9em;">Synchronize groups, distribution lists, and aliases from Exchange/Google. Enhance security by providing access to user contacts and mailboxes.</span>
				</div>

				<div class="content-container flex-column justify-content-center">
					<div class="flex-row flex-wrap gap-3 justify-content-start animated fadeIn">
						<ng-container *ngFor="let integration of integrationsEmailInfraData  | keyvalue: gs.returnZero; trackBy: gs.trackByIndex;">
							<ng-container>
								<ng-container *ngTemplateOutlet="integrationCardTemplate; context: {$implicit: integration}"></ng-container>
							</ng-container>
						</ng-container>

						<ng-template #integrationCardTemplate let-integration>
							<div class="flex-column gap-2 px-3 py-2 border border-1 rounded-2 bg-white cursor-pointer integration-service-card" style="width: 180px; min-height: 100px; transition: all 0.25s;"
								 [ngClass]="{'border-primary shadow' : selectedIntegrationObj?.key === integration.value.key}"
								 [ngStyle]="{'order' : integration.value?.enabled ? '0' : '1'}"
								 (click)="selectIntegration(integration.value)">
								<div class="flex-row justify-content-between align-items-center gap-3">
									<div class="d-flex centralize rounded-3 border border-1 bg-light p-1" style="width: 40px; height: 40px;">
										<img class="w-100" [src]="integration.value.logo" />
									</div>
									<span class="px-2 py-1 border border-1 rounded-2 text-center" style="font-size: 12px; width: 96px; transition: all 0.25s;"
										  [ngClass]="integration.value?.enabled ? 'border-success bg-success text-white text-success cursor-default' : 'text-muted cursor-pointer hvr-darken'">
								{{integration.value?.enabled ? 'Connected' : 'Not connected'}}
							</span>
								</div>
								<span class="fw-500 mt-1 integration-name" style="font-size: 15px;" [ngClass]="{'text-success' : integration.value?.enabled}">{{integration.key}}</span>
							</div>
						</ng-template>
					</div>
				</div>
			</div>


			<div class="list-group-item settings-list-item">
				<div class="flex-column gap-3" style="max-width: 300px;">
					<b>Identity Authentication</b>
					<span style="font-size: 0.9em;">Enables users to sign in and verify their identity using the SAML or OIDC protocols, providing secure and streamlined access to the application.</span>
				</div>

				<div class="content-container flex-column justify-content-center">
					<div class="flex-row flex-wrap gap-3 justify-content-start animated fadeIn">
						<ng-container *ngFor="let integration of integrationsAuthData  | keyvalue: gs.returnZero; trackBy: gs.trackByIndex;">
							<ng-container>
								<ng-container *ngTemplateOutlet="integrationCardTemplate; context: {$implicit: integration}"></ng-container>
							</ng-container>
						</ng-container>

						<ng-template #integrationCardTemplate let-integration>
							<div class="flex-column gap-2 px-3 py-2 border border-1 rounded-2 bg-white cursor-pointer integration-service-card" style="width: 180px; min-height: 100px; transition: all 0.25s;"
								 [ngClass]="{'border-primary shadow' : selectedIntegrationObj?.key === integration.value.key}"
								 [ngStyle]="{'order' : integration.value?.enabled ? '0' : '1'}"
								 (click)="selectIntegration(integration.value)">
								<div class="flex-row justify-content-between align-items-center gap-3">
									<div class="d-flex centralize rounded-3 border border-1 bg-light p-1" style="width: 40px; height: 40px;">
										<img class="w-100" [src]="integration.value.logo" />
									</div>
									<span class="px-2 py-1 border border-1 rounded-2 text-center" style="font-size: 12px; width: 96px; transition: all 0.25s;"
										  [ngClass]="integration.value?.enabled ? 'border-success bg-success text-white text-success cursor-default' : 'text-muted cursor-pointer hvr-darken'">
								{{integration.value?.enabled ? 'Connected' : 'Not connected'}}
							</span>
								</div>
								<span class="fw-500 mt-1 integration-name" style="font-size: 15px;" [ngClass]="{'text-success' : integration.value?.enabled}">{{integration.key}}</span>
							</div>
						</ng-template>
					</div>
				</div>
			</div>

			<div class="list-group-item settings-list-item">
				<div class="flex-column gap-3" style="max-width: 300px;">
					<b>SIEM</b>
					<span style="font-size: 0.9em;">Receive real-time event and security logs in your centralized SIEM. Gain visibility into quarantined email reports, account takeover alerts, and detailed audit log entries.</span>
				</div>

				<div class="content-container flex-column justify-content-center">
					<div class="flex-row flex-wrap gap-3 justify-content-start animated fadeIn">
						<ng-container *ngFor="let integration of integrationsSiemData  | keyvalue: gs.returnZero; trackBy: gs.trackByIndex;">
							<ng-container>
								<ng-container *ngTemplateOutlet="integrationCardTemplate; context: {$implicit: integration}"></ng-container>
							</ng-container>
						</ng-container>

						<ng-template #integrationCardTemplate let-integration>
							<div class="flex-column gap-2 px-3 py-2 border border-1 rounded-2 bg-white cursor-pointer integration-service-card" style="width: 180px; min-height: 100px; transition: all 0.25s;"
								 [ngClass]="{'border-primary shadow' : selectedIntegrationObj?.key === integration.value.key}"
								 [ngStyle]="{'order' : integration.value?.enabled ? '0' : '1'}"
								 (click)="selectIntegration(integration.value)">
								<div class="flex-row justify-content-between align-items-center gap-3">
									<div class="d-flex centralize rounded-3 border border-1 bg-light p-1" style="width: 40px; height: 40px;">
										<img class="w-100" [src]="integration.value.logo" />
									</div>
									<span class="px-2 py-1 border border-1 rounded-2 text-center" style="font-size: 12px; width: 96px; transition: all 0.25s;"
										  [ngClass]="integration.value?.enabled ? 'border-success bg-success text-white text-success cursor-default' : 'text-muted cursor-pointer hvr-darken'">
								{{integration.value?.enabled ? 'Connected' : 'Not connected'}}
							</span>
								</div>
								<span class="fw-500 mt-1 integration-name" style="font-size: 15px;" [ngClass]="{'text-success' : integration.value?.enabled}">{{integration.key}}</span>
							</div>
						</ng-template>
					</div>
				</div>
			</div>

			<div class="list-group-item settings-list-item">
				<div class="flex-column gap-3" style="max-width: 300px;">
					<b>PSA (Professional Services Automation)</b>
					<span style="font-size: 0.9em;">Integrate with your PSA platform to receive release requests for quarantined emails, as well as information about Account Takeover incidents.</span>
				</div>

				<div class="content-container flex-column justify-content-center">
					<div class="flex-row flex-wrap gap-3 justify-content-start animated fadeIn">
						<ng-container *ngFor="let integration of integrationsPsaData  | keyvalue: gs.returnZero; trackBy: gs.trackByIndex;">
							<ng-container>
								<ng-container *ngTemplateOutlet="integrationCardTemplate; context: {$implicit: integration}"></ng-container>
							</ng-container>
						</ng-container>

						<ng-template #integrationCardTemplate let-integration>
							<div class="flex-column gap-2 px-3 py-2 border border-1 rounded-2 bg-white cursor-pointer integration-service-card" style="width: 180px; min-height: 100px; transition: all 0.25s;"
								 [ngClass]="{'border-primary shadow' : selectedIntegrationObj?.key === integration.value.key}"
								 [ngStyle]="{'order' : integration.value?.enabled ? '0' : '1'}"
								 (click)="selectIntegration(integration.value)">
								<div class="flex-row justify-content-between align-items-center gap-3">
									<div class="d-flex centralize rounded-3 border border-1 bg-light p-1" style="width: 40px; height: 40px;">
										<img class="w-100" [src]="integration.value.logo" />
									</div>
									<span class="px-2 py-1 border border-1 rounded-2 text-center" style="font-size: 12px; width: 76px; transition: all 0.25s;"
										  [ngClass]="integration.value?.enabled ? 'border-success bg-success text-white text-success cursor-default' : 'text-muted cursor-pointer hvr-darken'">
								{{integration.value?.enabled ? 'Connected' : 'Connect'}}
							</span>
								</div>
								<span class="fw-500 mt-1 integration-name" style="font-size: 15px;" [ngClass]="{'text-success' : integration.value?.enabled}">{{integration.key}}</span>
								<!-- CC: taken from integrations.component.html -> Security & Data card desc -->
								<span style="font-size: 12px; color: #232323;" *ngIf="integration.value.desc">{{integration.value.desc}}</span>
							</div>
						</ng-template>
					</div>
				</div>
			</div>


			<div class="list-group-item settings-list-item">
				<div class="flex-column gap-3" style="max-width: 300px;">
					<b>Security & Data</b>
					<span style="font-size: 0.9em;">Integrate with your 3rd party security and storage platforms to enhance data protection and configure storage options for personal data.</span>
				</div>

				<div class="content-container flex-column justify-content-center">
					<div class="flex-row flex-wrap gap-3 justify-content-start animated fadeIn">
						<ng-container *ngFor="let integration of integrationsSecurityData  | keyvalue: gs.returnZero; trackBy: gs.trackByIndex;">
							<ng-container>
								<ng-container *ngTemplateOutlet="integrationCardTemplate; context: {$implicit: integration}"></ng-container>
							</ng-container>
						</ng-container>

						<ng-template #integrationCardTemplate let-integration>
							<div class="flex-column gap-2 px-3 py-2 border border-1 rounded-2 bg-white cursor-pointer integration-service-card" style="width: 330px; height: 150px; transition: all 0.25s;"
								 [ngClass]="{'border-primary shadow' : selectedIntegrationObj?.key === integration.value.key}"
								 [ngStyle]="{'order' : integration.value?.enabled ? '0' : '1'}"
								 (click)="selectIntegration(integration.value)">
								<div class="flex-row justify-content-between align-items-center gap-3">
									<div class="d-flex centralize rounded-3 border border-1 bg-light p-1" style="width: 40px; height: 40px;">
										<img class="w-100" [src]="integration.value.logo" />
									</div>
									<span class="px-2 py-1 border border-1 rounded-2 text-center" style="font-size: 12px; width: 76px; transition: all 0.25s;"
										  [ngClass]="integration.value?.enabled ? 'border-success bg-success text-white text-success cursor-default' : 'text-muted cursor-pointer hvr-darken'">
										{{integration.value?.enabled ? 'Connected' : 'Connect'}}
									</span>
								</div>
								<span class="fw-500 mt-1 integration-name" style="font-size: 15px;" [ngClass]="{'text-success' : integration.value?.enabled}">{{integration.key}}</span>
								<span style="font-size: 12px; color: #232323;" *ngIf="integration.value.desc">{{integration.value.desc}}</span>
							</div>
						</ng-template>
					</div>
				</div>
			</div>

		</div>

		<!--API tab-->
		<!-- CC: taken from account-api.component.html (was the account settings API tab), reused here as the API tab -->
		<account-api-component class="flex-column f-1-0 overflow-auto" *ngIf="isLoaded && activeTab === tabs.api"></account-api-component>

		<!--MCP tab-->
		<!-- CC: taken from account-mcp.component.html (the account settings MCP page), reused here as the MCP tab -->
		<account-mcp-component class="flex-column f-1-0 overflow-auto" *ngIf="isLoaded && activeTab === tabs.mcp" (openApiTab)="setActiveTab(tabs.api);"></account-mcp-component>

		<!--Webhooks tab-->
		<div class="list-group list-group-flush settings-list-container" *ngIf="isLoaded && activeTab === tabs.webHooks">
			<div class="list-group-item settings-list-item">
				<div class="flex-column gap-3" style="max-width: 300px;">
					<b>Webhooks</b>
					<span style="font-size: 0.9em;">Enable webhooks to receive real-time notifications on email activity, including delivery, bounces, and other tracking events directly from Trustifi</span>

					<btn-c
						[isDisabled]="this.webHooksUpdateInProcess"
						(action)="webHooksUpdateConfiguration();">
						Update
					</btn-c>
				</div>

				<div class="content-container flex-column justify-content-center">
					<div class="list-group list-group-flush settings-list-container no-borders">
						<div class="list-group-item border-bottom settings-list-item" style="padding: 20px 15px 10px !important;">
							<div class="flex-column gap-2" style="max-width: 300px;">
								<b>Enable</b>
								<span style="font-size: 0.9em;">When webhooks are enabled, real-time notifications for email activity will be sent to your endpoint.</span>
							</div>
							<div class="content-container flex-column justify-content-center">
								<checkbox id="webhookStatus"
										  [(model)]="planInfo.web_hooks.events.enabled">
								</checkbox>
							</div>
						</div>


						<div class="list-group-item border-bottom settings-list-item" style="padding: 20px 15px 10px !important;">
							<div class="flex-column gap-2" style="max-width: 300px;">
								<b>Events</b>
								<span style="font-size: 0.9em;">Select which email tracking events should generate notifications to your endpoint.</span>
							</div>
							<div class="content-container flex-column justify-content-center">

								<app-dropdown-c style="width: 300px;"
												[isDisabled]="!planInfo.web_hooks.events.enabled"
												[items]="webHooksEvents"
												[isMultipleSelection]="true"
												itemDisplayKey="name"
								></app-dropdown-c>
							</div>
						</div>

						<div class="list-group-item border-bottom settings-list-item" style="padding: 20px 15px 10px !important;">
							<div class="flex-column gap-2" style="max-width: 300px;">
								<b>Endpoint URL</b>
								<span style="font-size: 0.9em;">URL of your server endpoint that will receive the webhook notifications.</span>
								<btn-c
									[isDisabled]="!planInfo.web_hooks.events.url || this.webHooksUpdateInProcess"
									(action)="verifyWebhook();">
									Verify
								</btn-c>
							</div>
							<div class="content-container flex-column justify-content-center">
								<input style="width:100%; margin: 0;"
									   [disabled]="!planInfo.web_hooks.events.enabled"
									   type="text"
									   placeholder="endpoint url"
									   [(ngModel)]="planInfo.web_hooks.events.url">
							</div>
						</div>

						<div class="list-group-item border-bottom settings-list-item" style="padding: 20px 15px 10px !important;">
							<div class="flex-column gap-2" style="max-width: 300px;">
								<b>Users</b>
								<span style="font-size: 0.9em;">Select the users whose email tracking events will be sent to your configured endpoint.</span>
							</div>
							<div class="content-container flex-column justify-content-center">
								<input style="width:100%; margin: 0; cursor: pointer;"
									   (click)="openUsersFilterPopup()"
									   placeholder="All users"
									   type="text"
									   [(ngModel)]="planInfo.web_hooks.events.users">
							</div>
						</div>

						<div class="list-group-item border-bottom settings-list-item" style="padding: 20px 15px 10px !important;">
							<div class="flex-column gap-2" style="max-width: 300px;">
								<b>Secret</b>
								<span style="font-size: 0.9em;">Optional secret that your endpoint can use to validate incoming webhook requests from Trustifi.</span>
							</div>
							<div class="content-container flex-column justify-content-center">
								<input style="width:100%; margin: 0;"
									   type="text"
									   [disabled]="!planInfo.web_hooks.events.enabled"
									   placeholder="(optional)"
									   [(ngModel)]="planInfo.web_hooks.events.secret">
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!--HTML Templates-->
		<ng-template #verifyConnectionSectionTemplate let-subtitle="subtitle">
			<div class="flex-row gap-4">
				<div class="w-50 flex-column gap-2">
					<span style="font-weight: 500;" >Verify connection</span>
					<span style="font-size: 12px; max-width: 300px;">{{subtitle}}</span>
				</div>
				<div class="w-50">
					<btn-c style="width: 135px;"
						   [isDisabled]="integrationActionInProcess || !selectedIntegrationObj.enabled"
						   (action)="verifyIntegrationConnection(selectedIntegrationObj);">
						Verify
					</btn-c>
				</div>
			</div>
		</ng-template>

		<ng-template #connectSectionTemplate let-text="text">
			<div class="flex-row gap-4">
				<div class="w-50 flex-column gap-2">
					<span style="font-weight: 500;" [ngClass]="selectedIntegrationObj.enabled ? 'text-success' : 'text-warning'">{{selectedIntegrationObj.enabled ? 'Connected' : 'Disconnected'}}</span>
					<span style="font-size: 12px; max-width: 300px;" *ngIf="text">{{text}}</span>
					<span style="font-size: 12px; max-width: 300px;" *ngIf="!text">{{selectedIntegrationObj.enabled ? 'Your mail server is now integrated with ' + gs.corpname : 'Allow us to establish a secure connection to your mail server using admin-credentials.'}}</span>
				</div>
				<div class="w-50">
					<btn-c style="width: 135px;"
						   endIcon="far fa-plug"
						   [loading]="integrationActionInProcess"
						   (action)="connectToIntegration(selectedIntegrationObj);">
						{{selectedIntegrationObj.enabled ? 'Disconnect' : selectedIntegrationObj.name === dic.CONSTANTS.integrationType.powershell && planInfo?.powershell?.enabled ? 'Reconnect':'Connect'}}
					</btn-c>
				</div>
			</div>
		</ng-template>

		<ng-template #domainSectionTemplate let-domainsList="domainsList">
			<div class="flex-row gap-4">
				<div class="w-50 flex-column gap-2">
					<span style="font-weight: 500;">Domains</span>
					<span style="font-size: 12px; max-width: 300px;">Domains managed by your {{selectedIntegrationObj.name}} server</span>
				</div>
				<div class="w-50">
					<div *ngFor="let domain of domainsList">
						- {{domain}}
					</div>
					<span class="text-muted flex-row align-items-center h-100" *ngIf="!domainsList?.length">No verified domains</span>
				</div>
			</div>
		</ng-template>

		<ng-template #groupsAndAliasesSectionTemplate>
			<div class="flex-row gap-4">
				<div class="w-50 flex-column gap-2">
					<span style="font-weight: 500;">Groups/Aliases</span>
					<span style="font-size: 12px; max-width: 300px;">Knowing your groups/aliases will allow us to protect you better</span>
				</div>
				<div class="w-50 flxRow" style="flex-wrap: wrap; align-items: flex-start;">
					<btn-c style="width: 135px; margin: 0 5px 7px 0;"
						   endIcon="far fa-users"
						   (action)="getGroups(true);">
						Show Groups
					</btn-c>
					<btn-c style="width: 135px; margin: 0 5px 7px 0;"
						   endIcon="far fa-users"
						   (action)="getMailboxesAliases(true);">
						Show Aliases
					</btn-c>
					<btn-c style="width: 135px; margin: 0 5px 7px 0;"
						   [loading]="integrationActionInProcess"
						   endIcon="{{integImportGroupsSummary ? 'far fa-sync': 'far fa-users-cog'}}"
						   [isDisabled]="!selectedIntegrationObj.enabled || integrationActionInProcess"
						   (action)="integImportGroups();">
						{{integImportGroupsSummary ? 'Update ': 'Sync'}}
					</btn-c>
				</div>
			</div>
		</ng-template>

		<ng-template #guideSectionTemplate let-title="title" let-url="url">
			<div class="guide-link-wrapper flxRow hSpace05" style="align-self: flex-end; font-weight: 500;">
				<span>Full guide:</span>
				<a class="a-link" [href]="dic.CONSTANTS.trustifiDefault.resources.docsGeneral + url" target="_blank">{{title}}</a>
			</div>
		</ng-template>
	</div>
</div>



<popup-c *ngIf="selectedIntegrationObj"
		 head="{{selectedIntegrationObj?.name}} Integration"
		 size="dynamic" width="750px"
		 class="bs-enabled"
		 (closeCb)="selectedIntegrationObj = null;">

	<ng-container [ngSwitch]="selectedIntegrationObj?.name">

		<!--Open ID popup-->
		<div class="flex-column f-1-0 overflow-auto gap-4" *ngSwitchCase="dic.CONSTANTS.integrationType.openid">
			<ng-container *ngTemplateOutlet="connectSectionTemplate; context: {text: selectedIntegrationObj.enabled ? 'You are now integrated with authentication service provider using OIDC' : 'Allow us to establish a secure connection to your authentication service provider using OIDC'}"></ng-container>

			<ng-container *ngIf="selectedIntegrationObj.enabled">
				<div class="flex-row gap-4">
					<div class="w-50 flex-column gap-2">
						<span style="font-weight: 500;">Discovery Document ("well-known") Endpoint</span>
						<span style="font-size: 12px; max-width: 300px;">Integrated to the following OIDC Authorization Server</span>
					</div>
					<div class="w-50">
						<span>{{planInfo?.integrations.openid.metadata}}</span>
					</div>
				</div>
				<div class="flex-row gap-4">
					<div class="w-50 flex-column gap-2">
						<span style="font-weight: 500;">User Info Endpoint</span>
						<span style="font-size: 12px; max-width: 300px;">Integrated to the following OIDC Authorization Server</span>
					</div>
					<div class="w-50">
						<span>{{planInfo?.integrations.openid.userinfo_endpoint}}</span>
					</div>
				</div>
				<div class="flex-row gap-4">
					<div class="w-50 flex-column gap-2">
						<span style="font-weight: 500;">Authorization Endpoint</span>
						<span style="font-size: 12px; max-width: 300px;">Integrated to the following OIDC Authorization Server</span>
					</div>
					<div class="w-50">
						<span>{{planInfo?.integrations.openid.auth_endpoint}}</span>
					</div>
				</div>
				<div class="flex-row gap-4" *ngIf="planInfo?.integrations.openid.logout_endpoint">
					<div class="w-50 flex-column gap-2">
						<span style="font-weight: 500;">End Session Endpoint</span>
						<span style="font-size: 12px; max-width: 300px;">Integrated to the following OIDC Authorization Server</span>
					</div>
					<div class="w-50">
						<span>{{planInfo?.integrations.openid.logout_endpoint}}</span>
					</div>
				</div>
				<div class="flex-row gap-4">
					<div class="w-50 flex-column gap-2">
						<span style="font-weight: 500;">Client ID</span>
						<span style="font-size: 12px; max-width: 300px;">OIDC remote application Client ID</span>
					</div>
					<div class="w-50">
						<span>{{planInfo?.integrations.openid.clientId}}</span>
					</div>
				</div>
			</ng-container>

			<ng-container *ngTemplateOutlet="domainSectionTemplate; context: {domainsList: planInfo.integrations.openid?.domains || []}"></ng-container>

			<ng-container *ngTemplateOutlet="verifyConnectionSectionTemplate; context: {subtitle: 'Check if your OIDC connection\'s credentials are still active and valid'}"></ng-container>

			<div class="guide-link-wrapper flxRow hSpace05" style="align-self: flex-end; font-weight: 500;">
				<span>Full integration guides:</span>
				<a class="a-link" [href]="dic.CONSTANTS.trustifiDefault.resources.docsGeneral + '/open-id-integration-with-okta'" target="_blank">Okta</a>
				<span>,</span>
				<a class="a-link" [href]="dic.CONSTANTS.trustifiDefault.resources.docsGeneral + '/open-id-integration-with-azure'" target="_blank">Azure</a>
			</div>
		</div>

		<!--Saml popup-->
		<div class="flex-column f-1-0 overflow-auto gap-4" *ngSwitchCase="dic.CONSTANTS.integrationType.saml">

			<ng-container *ngTemplateOutlet="connectSectionTemplate; context: {text: selectedIntegrationObj.enabled ? 'You are now integrated with authentication service provider using SAML' : 'Allow us to establish a secure connection to your authentication service provider using SAML'}"></ng-container>

			<ng-container *ngIf="selectedIntegrationObj.enabled">
				<div class="flex-row gap-4">
					<div class="w-50 flex-column gap-2">
						<span style="font-weight: 500;">Sign On URL</span>
						<span style="font-size: 12px; max-width: 300px;">Integrated to the following SAML Authorization Server</span>
					</div>
					<div class="w-50">
						<span>{{planInfo?.integrations.saml.signOnURL}}</span>
					</div>
				</div>
				<div class="flex-row gap-4" *ngIf="planInfo?.integrations.saml.logoutURL">
					<div class="w-50 flex-column gap-2">
						<span style="font-weight: 500;">Logout URL</span>
						<span style="font-size: 12px; max-width: 300px;">Integrated to the following SAML Authorization Server</span>
					</div>
					<div class="w-50">
						<span>{{planInfo?.integrations.saml.logoutURL}}</span>
					</div>
				</div>
				<div class="flex-row gap-4">
					<div class="w-50 flex-column gap-2">
						<span style="font-weight: 500;">Entity ID</span>
						<span style="font-size: 12px; max-width: 300px;">Integrated to the following SAML Authorization Server</span>
					</div>
					<div class="w-50">
						<span>{{planInfo?.integrations.saml.entityID}}</span>
					</div>
				</div>
			</ng-container>

			<ng-container *ngTemplateOutlet="domainSectionTemplate; context: {domainsList: planInfo.integrations.saml?.domains || []}"></ng-container>

			<ng-container *ngTemplateOutlet="verifyConnectionSectionTemplate; context: {subtitle: 'Check if your SAML connection\'s credentials are still active and valid'}"></ng-container>

			<div class="guide-link-wrapper flxRow hSpace05" style="align-self: flex-end; font-weight: 500;">
				<span>Full integration guides:</span>
				<a class="a-link" [href]="dic.CONSTANTS.trustifiDefault.resources.docsGeneral + '/saml-integration-with-okta'" target="_blank">Okta</a>
				<span>,</span>
				<a class="a-link" [href]="dic.CONSTANTS.trustifiDefault.resources.docsGeneral + '/saml-integration-with-azure'" target="_blank">Azure</a>
			</div>
		</div>

		<!--Splunk popup-->
		<div class="flex-column f-1-0 overflow-auto gap-4" *ngSwitchCase="dic.CONSTANTS.integrationType.splunk">
			<div class="flex-column info-banner fw-normal gap-2">
				<span>This integration will be used to send logs for the following event types:</span>
				<ul>
					<li>Inbound emails being quarantined.</li>
					<li>Account Takeover incidents.</li>
					<li>Audit logs entries.</li>
				</ul>
			</div>

			<ng-container *ngTemplateOutlet="connectSectionTemplate; context: {text: selectedIntegrationObj.enabled ? 'Your SIEM is now connected to ' + gs.corpname : 'Click on &quot;Connect&quot; to establish a secure connection with your SIEM instance'}" ></ng-container>

			<ng-container *ngTemplateOutlet="verifyConnectionSectionTemplate; context: {subtitle: 'Click to verify your integration is configured correctly'}"></ng-container>

			<ng-container *ngTemplateOutlet="guideSectionTemplate; context: {title: 'Splunk Integration', url: '/splunk-integration'}"></ng-container>
		</div>

		<!--QRadar popup-->
		<!-- CC: taken from integrations.component.html -> Splunk popup switch case -->
		<div class="flex-column f-1-0 overflow-auto gap-4" *ngSwitchCase="dic.CONSTANTS.integrationType.qradar">
			<div class="flex-column info-banner fw-normal gap-2">
				<span>This integration will be used to send logs for the following event types:</span>
				<ul>
					<li>Inbound emails being quarantined.</li>
					<li>Account Takeover incidents.</li>
					<li>Audit logs entries.</li>
				</ul>
			</div>

			<ng-container *ngTemplateOutlet="connectSectionTemplate; context: {text: selectedIntegrationObj.enabled ? 'Your SIEM is now connected to ' + gs.corpname : 'Click on &quot;Connect&quot; to establish a secure connection with your SIEM instance'}" ></ng-container>

			<ng-container *ngTemplateOutlet="verifyConnectionSectionTemplate; context: {subtitle: 'Click to verify your integration is configured correctly'}"></ng-container>
		</div>

		<!--Graylog popup-->
		<!-- CC: taken from integrations.component.html -> QRadar popup switch case -->
		<div class="flex-column f-1-0 overflow-auto gap-4" *ngSwitchCase="dic.CONSTANTS.integrationType.graylog">
			<div class="flex-column info-banner fw-normal gap-2">
				<span>This integration will be used to send logs for the following event types:</span>
				<ul>
					<li>Inbound emails being quarantined.</li>
					<li>Account Takeover incidents.</li>
					<li>Audit logs entries.</li>
				</ul>
			</div>

			<ng-container *ngTemplateOutlet="connectSectionTemplate; context: {text: selectedIntegrationObj.enabled ? 'Your SIEM is now connected to ' + gs.corpname : 'Click on &quot;Connect&quot; to establish a secure connection with your SIEM instance'}" ></ng-container>

			<ng-container *ngTemplateOutlet="verifyConnectionSectionTemplate; context: {subtitle: 'Click to verify your integration is configured correctly'}"></ng-container>
		</div>

		<!--SentinelOne popup-->
		<div class="flex-column f-1-0 overflow-auto gap-4" *ngSwitchCase="dic.CONSTANTS.integrationType.sentinelOne">
			<div class="flex-column info-banner fw-normal gap-2">
				<span>This integration will be used to send logs for the following event types:</span>
				<ul>
					<li>Inbound emails being quarantined.</li>
					<li>Account Takeover incidents.</li>
					<li>Audit logs entries.</li>
				</ul>
			</div>

			<ng-container *ngTemplateOutlet="connectSectionTemplate; context: {text: selectedIntegrationObj.enabled ? 'Your SIEM is now connected to ' + gs.corpname : 'Click on &quot;Connect&quot; to establish a secure connection with your SIEM instance'}" ></ng-container>

			<ng-container *ngTemplateOutlet="verifyConnectionSectionTemplate; context: {subtitle: 'Click to verify your integration is configured correctly'}"></ng-container>
		</div>

		<!--Sumo Logic popup-->
		<div class="flex-column f-1-0 overflow-auto gap-4" *ngSwitchCase="dic.CONSTANTS.integrationType.sumoLogic">
			<div class="flex-column info-banner fw-normal gap-2">
				<span>This integration will be used to send logs for the following event types:</span>
				<ul>
					<li>Inbound emails being quarantined.</li>
					<li>Account Takeover incidents.</li>
					<li>Audit logs entries.</li>
				</ul>
			</div>

			<ng-container *ngTemplateOutlet="connectSectionTemplate; context: {text: selectedIntegrationObj.enabled ? 'Your SIEM is now connected to ' + gs.corpname : 'Click on &quot;Connect&quot; to establish a secure connection with your SIEM instance'}" ></ng-container>

			<ng-container *ngTemplateOutlet="verifyConnectionSectionTemplate; context: {subtitle: 'Click to verify your integration is configured correctly'}"></ng-container>
		</div>

		<!--Rapid7 popup-->
		<div class="flex-column f-1-0 overflow-auto gap-4" *ngSwitchCase="dic.CONSTANTS.integrationType.rapid7">
			<div class="flex-column info-banner fw-normal gap-2">
				<span>This integration will be used to send logs for the following event types:</span>
				<ul>
					<li>Inbound emails being quarantined.</li>
					<li>Account Takeover incidents.</li>
					<li>Audit logs entries.</li>
				</ul>
			</div>

			<ng-container *ngTemplateOutlet="connectSectionTemplate; context: {text: selectedIntegrationObj.enabled ? 'Your SIEM is now connected to ' + gs.corpname : 'Click on &quot;Connect&quot; to establish a secure connection with your SIEM instance'}" ></ng-container>

			<ng-container *ngTemplateOutlet="verifyConnectionSectionTemplate; context: {subtitle: 'Click to verify your integration is configured correctly'}"></ng-container>
		</div>

		<!--CrowdStrike popup-->
		<div class="flex-column f-1-0 overflow-auto gap-4" *ngSwitchCase="dic.CONSTANTS.integrationType.crowdStrike">
			<div class="flex-column info-banner fw-normal gap-2">
				<span>This integration will be used to send logs for the following event types:</span>
				<ul>
					<li>Inbound emails being quarantined.</li>
					<li>Account Takeover incidents.</li>
					<li>Audit logs entries.</li>
				</ul>
			</div>

			<ng-container *ngTemplateOutlet="connectSectionTemplate; context: {text: selectedIntegrationObj.enabled ? 'Your SIEM is now connected to ' + gs.corpname : 'Click on &quot;Connect&quot; to establish a secure connection with your SIEM instance'}" ></ng-container>

			<ng-container *ngTemplateOutlet="verifyConnectionSectionTemplate; context: {subtitle: 'Click to verify your integration is configured correctly'}"></ng-container>
		</div>

		<!--Huntress popup-->
		<div class="flex-column f-1-0 overflow-auto gap-4" *ngSwitchCase="dic.CONSTANTS.integrationType.huntress">
			<div class="flex-column info-banner fw-normal gap-2">
				<span>This integration will be used to send logs for the following event types:</span>
				<ul>
					<li>Inbound emails being quarantined.</li>
					<li>Account Takeover incidents.</li>
					<li>Audit logs entries.</li>
				</ul>
			</div>

			<ng-container *ngTemplateOutlet="connectSectionTemplate; context: {text: selectedIntegrationObj.enabled ? 'Your SIEM is now connected to ' + gs.corpname : 'Click on &quot;Connect&quot; to establish a secure connection with your SIEM instance'}" ></ng-container>

			<ng-container *ngTemplateOutlet="verifyConnectionSectionTemplate; context: {subtitle: 'Click to verify your integration is configured correctly'}"></ng-container>
		</div>

		<!--Halo PSA popup-->
		<div class="flex-column f-1-0 overflow-auto gap-4" *ngSwitchCase="dic.CONSTANTS.integrationType.haloPSA">
			<div class="flex-column info-banner fw-normal gap-2">
				<span>This integration will be used to send logs for the following event types:</span>
				<ul>
					<li>Inbound email release requests</li>
					<li>Account Takeover incidents</li>
				</ul>
			</div>

			<ng-container *ngTemplateOutlet="connectSectionTemplate; context: {text: selectedIntegrationObj.enabled ? 'Your integration is now connected to ' + gs.corpname : 'Click on &quot;Connect&quot; to establish a secure connection with your integration instance'}" ></ng-container>

			<ng-container *ngTemplateOutlet="verifyConnectionSectionTemplate; context: {subtitle: 'Click to verify your integration is configured correctly'}"></ng-container>

			<ng-container *ngIf="selectedIntegrationObj.enabled">
				<div class="flex-row gap-4">
					<div class="w-50 flex-column gap-2">
						<span style="font-weight: 500;">Tenant:</span>
					</div>
					<div class="w-50">
						<span>{{planInfo.integrations.haloPSA.tenant}}</span>
					</div>
				</div>
				<div class="flex-row gap-4">
					<div class="w-50 flex-column gap-2">
						<span style="font-weight: 500;">Client ID:</span>
					</div>
					<div class="w-50">
						<span>{{planInfo.integrations.haloPSA.client_id}}</span>
					</div>
				</div>
				<div class="flex-row gap-4" *ngIf="planInfo.integrations.haloPSA.category">
					<div class="w-50 flex-column gap-2">
						<span style="font-weight: 500;">Ticket Category:</span>
					</div>
					<div class="w-50">
						<span>{{planInfo.integrations.haloPSA.category}}</span>
					</div>
				</div>
				<div class="flex-row gap-4" *ngIf="planInfo.integrations.haloPSA.ticket_type">
					<div class="w-50 flex-column gap-2">
						<span style="font-weight: 500;">Ticket Type:</span>
					</div>
					<div class="w-50">
						<span>{{planInfo.integrations.haloPSA.ticket_type}}</span>
					</div>
				</div>
			</ng-container>
		</div>

		<!--ConnectWise popup-->
		<div class="flex-column f-1-0 overflow-auto gap-4" *ngSwitchCase="dic.CONSTANTS.integrationType.connectWise">
			<div class="flex-column info-banner fw-normal gap-2">
				<span>This integration will be used to send logs for the following event types:</span>
				<ul>
					<li>Inbound email release requests</li>
				</ul>
			</div>

			<ng-container *ngTemplateOutlet="connectSectionTemplate; context: {text: selectedIntegrationObj.enabled ? 'Your integration is now connected to ' + gs.corpname : 'Click on &quot;Connect&quot; to establish a secure connection with your integration instance'}" ></ng-container>

			<ng-container *ngTemplateOutlet="verifyConnectionSectionTemplate; context: {subtitle: 'Click to verify your integration is configured correctly'}"></ng-container>

			<ng-container *ngIf="selectedIntegrationObj.enabled">
				<div class="flex-row gap-4">
					<div class="w-50 flex-column gap-2">
						<span style="font-weight: 500;">Tenant:</span>
					</div>
					<div class="w-50">
						<span>{{planInfo.integrations.connectWise.tenant}}</span>
					</div>
				</div>
				<div class="flex-row gap-4">
					<div class="w-50 flex-column gap-2">
						<span style="font-weight: 500;">Client ID:</span>
					</div>
					<div class="w-50">
						<span>{{planInfo.integrations.connectWise.client_id}}</span>
					</div>
				</div>
				<div class="flex-row gap-4">
					<div class="w-50 flex-column gap-2">
						<span style="font-weight: 500;">Authorization Server:</span>
					</div>
					<div class="w-50">
						<span>{{planInfo.integrations.connectWise.auth_server}}</span>
					</div>
				</div>
				<div class="flex-row gap-4">
					<div class="w-50 flex-column gap-2">
						<span style="font-weight: 500;">Resource Server:</span>
					</div>
					<div class="w-50">
						<span>{{planInfo.integrations.connectWise.resource_server}}</span>
					</div>
				</div>
				<div class="flex-row gap-4">
					<div class="w-50 flex-column gap-2">
						<span style="font-weight: 500;">Ticket Category:</span>
					</div>
					<div class="w-50">
						<span>{{planInfo.integrations.connectWise.category}}</span>
					</div>
				</div>
				<div class="flex-row gap-4" *ngIf="planInfo.integrations.connectWise.ticket_type">
					<div class="w-50 flex-column gap-2">
						<span style="font-weight: 500;">Ticket Type:</span>
					</div>
					<div class="w-50">
						<span>{{planInfo.integrations.connectWise.ticket_type}}</span>
					</div>
				</div>
			</ng-container>
		</div>

		<!--Autotask popup-->
		<!-- CC: taken from integrations.component.html -> ConnectWise popup switch case -->
		<div class="flex-column f-1-0 overflow-auto gap-4" *ngSwitchCase="dic.CONSTANTS.integrationType.autotask">
			<div class="flex-column info-banner fw-normal gap-2">
				<span>This integration will be used to send logs for the following event types:</span>
				<ul>
					<li>Inbound email release requests</li>
					<li>Account Takeover incidents</li>
				</ul>
			</div>

			<ng-container *ngTemplateOutlet="connectSectionTemplate; context: {text: selectedIntegrationObj.enabled ? 'Your integration is now connected to ' + gs.corpname : 'Click on &quot;Connect&quot; to establish a secure connection with your integration instance'}" ></ng-container>

			<ng-container *ngTemplateOutlet="verifyConnectionSectionTemplate; context: {subtitle: 'Click to verify your integration is configured correctly'}"></ng-container>

			<ng-container *ngIf="selectedIntegrationObj.enabled">
				<div class="flex-row gap-4">
					<div class="w-50 flex-column gap-2">
						<span style="font-weight: 500;">Username:</span>
					</div>
					<div class="w-50">
						<span>{{planInfo.integrations.autoTask.username}}</span>
					</div>
				</div>
				<div class="flex-row gap-4">
					<div class="w-50 flex-column gap-2">
						<span style="font-weight: 500;">Company ID:</span>
					</div>
					<div class="w-50">
						<span>{{planInfo.integrations.autoTask.company_id}}</span>
					</div>
				</div>
				<div class="flex-row gap-4">
					<div class="w-50 flex-column gap-2">
						<span style="font-weight: 500;">Queue ID:</span>
					</div>
					<div class="w-50">
						<span>{{planInfo.integrations.autoTask.queue_id}}</span>
					</div>
				</div>
			</ng-container>
		</div>

		<!--SuperOps popup-->
		<!-- CC: taken from integrations.component.html -> Autotask popup switch case -->
		<div class="flex-column f-1-0 overflow-auto gap-4" *ngSwitchCase="dic.CONSTANTS.integrationType.superOps">
			<div class="flex-column info-banner fw-normal gap-2">
				<span>This integration will be used to send logs for the following event types:</span>
				<ul>
					<li>Inbound email release requests</li>
					<li>Account Takeover incidents</li>
				</ul>
			</div>

			<ng-container *ngTemplateOutlet="connectSectionTemplate; context: {text: selectedIntegrationObj.enabled ? 'Your integration is now connected to ' + gs.corpname : 'Click on &quot;Connect&quot; to establish a secure connection with your integration instance'}" ></ng-container>

			<ng-container *ngTemplateOutlet="verifyConnectionSectionTemplate; context: {subtitle: 'Click to verify your integration is configured correctly'}"></ng-container>

			<ng-container *ngIf="selectedIntegrationObj.enabled">
				<div class="flex-row gap-4">
					<div class="w-50 flex-column gap-2">
						<span style="font-weight: 500;">Subdomain:</span>
					</div>
					<div class="w-50">
						<span>{{planInfo.integrations.superOps.subdomain}}</span>
					</div>
				</div>
				<div class="flex-row gap-4">
					<div class="w-50 flex-column gap-2">
						<span style="font-weight: 500;">Data Center:</span>
					</div>
					<div class="w-50">
						<span>{{planInfo.integrations.superOps.data_center === 'eu' ? 'EU' : 'US'}}</span>
					</div>
				</div>
			</ng-container>
		</div>

		<!--XSIAM popup-->
		<div class="flex-column f-1-0 overflow-auto gap-4" *ngSwitchCase="dic.CONSTANTS.integrationType.xsiam">
			<div class="flex-column info-banner fw-normal gap-2">
				<span>This integration will be used to send logs for the following event types:</span>
				<ul>
					<li>Inbound emails being quarantined.</li>
					<li>Account Takeover incidents.</li>
					<li>Audit logs entries.</li>
				</ul>
			</div>

			<ng-container *ngTemplateOutlet="connectSectionTemplate; context: {text: selectedIntegrationObj.enabled ? 'Your SIEM is now connected to ' + gs.corpname : 'Click on &quot;Connect&quot; to establish a secure connection with your SIEM instance'}" ></ng-container>

			<ng-container *ngTemplateOutlet="verifyConnectionSectionTemplate; context: {subtitle: 'Click to verify your integration is configured correctly'}"></ng-container>
		</div>

		<!--Azure EventHub popup-->
		<div class="flex-column f-1-0 overflow-auto gap-4" *ngSwitchCase="dic.CONSTANTS.integrationType.eventhub">
			<div class="flex-column info-banner fw-normal gap-2">
				<span>This integration will be used to send logs for the following event types:</span>
				<ul>
					<li>Inbound emails being quarantined.</li>
					<li>Account Takeover incidents.</li>
					<li>Audit logs entries.</li>
				</ul>
			</div>

			<ng-container *ngTemplateOutlet="connectSectionTemplate; context: {text: selectedIntegrationObj.enabled ? 'Your SIEM is now connected to ' + gs.corpname + ' via Azure EventHub' : 'Click on &quot;Connect&quot; to establish a secure connection with your SIEM instance'}" ></ng-container>

			<ng-container *ngTemplateOutlet="verifyConnectionSectionTemplate; context: {subtitle: 'Click to verify your integration is configured correctly'}"></ng-container>
		</div>

		<!--Microsoft Sentinel popup-->
		<!-- CC: taken from integrations.component.html -> Azure EventHub popup switch case -->
		<div class="flex-column f-1-0 overflow-auto gap-4" *ngSwitchCase="dic.CONSTANTS.integrationType.microsoftSentinel">
			<div class="flex-column info-banner fw-normal gap-2">
				<span>This integration will be used to send logs for the following event types:</span>
				<ul>
					<li>Inbound emails being quarantined.</li>
					<li>Account Takeover incidents.</li>
					<li>Audit logs entries.</li>
				</ul>
			</div>

			<ng-container *ngTemplateOutlet="connectSectionTemplate; context: {text: selectedIntegrationObj.enabled ? 'Your SIEM is now connected to ' + gs.corpname : 'Click on &quot;Connect&quot; to establish a secure connection with your SIEM instance'}" ></ng-container>

			<ng-container *ngTemplateOutlet="verifyConnectionSectionTemplate; context: {subtitle: 'Click to verify your integration is configured correctly'}"></ng-container>
		</div>

		<!--Stellar Cyber popup-->
		<!-- CC: taken from integrations.component.html -> CrowdStrike panel -->
		<div class="flex-column f-1-0 overflow-auto gap-4" *ngSwitchCase="dic.CONSTANTS.integrationType.stellarCyber">
			<div class="flex-column info-banner fw-normal gap-2">
				<span>This integration will be used to send logs for the following event types:</span>
				<ul>
					<li>Inbound emails being quarantined.</li>
					<li>Account Takeover incidents.</li>
					<li>Audit logs entries.</li>
				</ul>
			</div>

			<ng-container *ngTemplateOutlet="connectSectionTemplate; context: {text: selectedIntegrationObj.enabled ? 'Your SIEM is now connected to ' + gs.corpname : 'Click on &quot;Connect&quot; to establish a secure connection with your SIEM instance'}" ></ng-container>

			<ng-container *ngTemplateOutlet="verifyConnectionSectionTemplate; context: {subtitle: 'Click to verify your integration is configured correctly'}"></ng-container>
		</div>

		<!--Syslog popup-->
		<div class="flex-column f-1-0 overflow-auto gap-4" *ngSwitchCase="dic.CONSTANTS.integrationType.syslog">
			<div class="flex-column info-banner fw-normal gap-2">
				<span>This integration will be used to send logs for the following event types:</span>
				<ul>
					<li>Inbound emails being quarantined.</li>
					<li>Account Takeover incidents.</li>
					<li>Audit logs entries.</li>
				</ul>
			</div>

			<ng-container *ngTemplateOutlet="connectSectionTemplate; context: {text: selectedIntegrationObj.enabled ? 'Your SIEM is now connected to ' + gs.corpname + ' via Syslog' : 'Allow us to establish a secure Syslog connection to your SIEM'}"></ng-container>

			<div class="flex-row gap-4" *ngIf="selectedIntegrationObj.enabled">
				<div class="w-50 flex-column gap-2">
					<span style="font-weight: 500;">Connection Details</span>
					<span style="font-size: 12px; max-width: 300px;">Syslog server connection information</span>
				</div>
				<div class="w-50 flex-column vSpace2">
					<span><b>Host:&nbsp;</b>{{planInfo?.integrations.syslog.host}}</span>
					<span><b>Port:&nbsp;</b>{{planInfo?.integrations.syslog.port}}</span>
					<div>
						<span><b>Protocol:&nbsp;</b><span style="text-transform: uppercase;">{{planInfo?.integrations.syslog.protocol}}</span></span>
						<span *ngIf="planInfo?.integrations.syslog.protocol === 'tcp'" >
								<br/>(Messages will be sent from static IPs: 3.227.182.193, 54.161.96.109)
							</span>
					</div>
				</div>
			</div>

			<ng-container *ngTemplateOutlet="verifyConnectionSectionTemplate; context: {subtitle: gs.corpname + ' will send you a test log to your Syslog server'}"></ng-container>
		</div>

		<!--Powershell popup-->
		<powershell-integration-component class="flex-column f-1-0 overflow-auto" *ngSwitchCase="dic.CONSTANTS.integrationType.powershell"
			(connectionChanged)="getIntegrations()">
		</powershell-integration-component>

		<!--Exchange popup-->
		<exchange-integration-component class="flex-column f-1-0 overflow-auto" *ngSwitchCase="dic.CONSTANTS.integrationType.exchange"
			(connectionChanged)="getIntegrations()">
		</exchange-integration-component>

		<!--Gsuite popup-->
		<gsuite-integration-component class="flex-column f-1-0 overflow-auto" *ngSwitchCase="dic.CONSTANTS.integrationType.gsuite"
			(connectionChanged)="getIntegrations()">
		</gsuite-integration-component>

		<!--Checkpoint popup-->
		<div class="flex-column f-1-0 overflow-auto gap-4" *ngSwitchCase="dic.CONSTANTS.integrationType.checkpoint">
			<ng-container *ngTemplateOutlet="connectSectionTemplate"></ng-container>

			<div class="flex-row gap-4" *ngIf="selectedIntegrationObj.enabled">
				<div class="w-50 flex-column gap-2">
					<span style="font-weight: 500;">Connection details</span>
				</div>
				<div class="w-50">
					<table class="simpleDataTableShrink middle">
						<tr>
							<td><b>Client ID:&nbsp;</b></td>
							<td><span>{{planInfo?.integrations.checkpoint.clientId}}</span></td>
						</tr>
					</table>
				</div>
			</div>

			<ng-container *ngTemplateOutlet="verifyConnectionSectionTemplate; context: {subtitle: 'Check if your Check Point connection\'s credentials are still active and valid'}"></ng-container>

			<ng-container *ngTemplateOutlet="guideSectionTemplate; context: {title: 'CheckPoint integration', url: '/checkpoint-integration'}"></ng-container>
		</div>

		<!--S3 popup-->
		<div class="flex-column f-1-0 overflow-auto gap-4" *ngSwitchCase="dic.CONSTANTS.integrationType.s3">
			<ng-container *ngTemplateOutlet="connectSectionTemplate"></ng-container>

			<div class="flex-row gap-4" *ngIf="selectedIntegrationObj.enabled">
				<div class="w-50 flex-column gap-2">
					<span style="font-weight: 500;">Connection details</span>
				</div>
				<div class="w-50">
					<table class="simpleDataTableShrink middle">
						<tr>
							<td><b>Remote Account ID:&nbsp;</b></td>
							<td><span>{{planInfo?.integrations.s3.remote_account_id}}</span></td>
						</tr>
						<tr>
							<td><b>Remote Role:&nbsp;</b></td>
							<td><span>{{planInfo?.integrations.s3.remote_role}}</span></td>
						</tr>
						<tr>
							<td><b>Use your own server-side encryption:&nbsp;</b></td>
							<td><span>{{planInfo?.integrations.s3.use_predefined_sse}}</span></td>
						</tr>
						<tr *ngIf="planInfo?.integrations.s3.attachments">
							<td><b>Attachments Bucket:&nbsp;</b></td>
							<td><span>{{planInfo?.integrations.s3.attachments}}</span></td>
						</tr>
						<tr *ngIf="planInfo?.integrations.s3.content">
							<td><b>Content Bucket:&nbsp;</b></td>
							<td><span>{{planInfo?.integrations.s3.content}}</span></td>
						</tr>
						<tr *ngIf="planInfo?.integrations.s3.quarantinedEmail">
							<td><b>Quarantined Bucket:&nbsp;</b></td>
							<td><span>{{planInfo?.integrations.s3.quarantinedEmail}}</span></td>
						</tr>
						<tr *ngIf="planInfo?.integrations.s3.archiving">
							<td><b>Archiving Bucket:&nbsp;</b></td>
							<td><span>{{planInfo?.integrations.s3.archiving}}</span></td>
						</tr>
					</table>
				</div>
			</div>

			<ng-container *ngTemplateOutlet="verifyConnectionSectionTemplate; context: {subtitle: 'Check if your Amazon S3 connection\'s credentials and buckets are still active and valid'}"></ng-container>
		</div>

		<!--Ldap popup-->
		<ldap-integration-component *ngSwitchCase="dic.CONSTANTS.integrationType.ldap"
			(connectionChanged)="getIntegrations();">
		</ldap-integration-component>
	</ng-container>
</popup-c>


<groups-popup-c *ngIf="showGroups"
				(cancelCb)="getGroups(false)"
				popupTitle="Groups"
				[showActions]="true">
</groups-popup-c>

<aliases-popup-c *ngIf="showAliases"
				 (cancelCb)="getMailboxesAliases(false)"
				 popupTitle="Aliases"
				 [showActions]="true">
</aliases-popup-c>

<!--Integration popup: Open ID-->
<popup-c *ngIf="openIDConfigPopup?.show"
		 head="Configure Integration with OIDC" size="large" height="auto"
		 (closeCb)="openIDConfigPopup = null;"
		 (confirmCb)="connectOpenIDExecute();"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Connect', loading: integrationActionInProcess}}">
	<div class="flxClmn">
		<span style="font-size: 16px;">Integrate your identity provider with {{gs.corpname}} using OIDC by following the instructions below</span>
		<!--                    <span style="font-size: 16px; margin-left: 3px; color: cornflowerblue" class="">*</span>-->
		<br/><br/>
		<div class="list-group list-group-flush">
			<div class="list-group-item">
				<p style="line-height: 1.45rem; margin-block-end: 0;">
					1. Enter the inputs below in your identity provider's configuration:
				</p>
				<div *ngFor="let redirect of openIDRedirectUrl; index as index;" style="align-items: center; margin:7px 15px;" class="flxRow-start hSpace2">
					<i class="fa fa-circle" style="font-size: 0.5em;"></i>
					<div style="font-size: 16px; width: auto; background: #bac9d642; height: 30px; align-items: center;" class="flxClmn-center">
						<span style="font-weight:500; overflow: auto; width: 100%; text-align: center;" class="hide-scrollbar click-select-all">{{redirect.url}}</span>
					</div>
					<a (click)="copyText(openIDRedirectUrl[index].url); $event.stopPropagation();"><i class="far fa-copy copy-link" tooltip="Copy URI"></i></a>
					<span style="font-size:0.9em;">({{redirect.description}})</span>
				</div>
			</div>
			<div class="list-group-item">
				<p style="line-height: 1.45rem; margin-block-end: 0;">
					2. Save the app integration. The new app integration should appear in your admin dashboard.
				</p>
			</div>
			<div class="list-group-item flex-column gap-2">
				<p style="line-height: 1.45rem; margin-block-end: 0;">
					3. Enter below the required information from your authentication service provider and click <b>Connect</b>
				</p>
				<div class="align-items-center d-flex gap-2">
					<div class="col-4">
						<span>Discovery Document ("well-known") Endpoint: </span>
					</div>
					<input style="width:350px; margin: 0;" type="text" [(ngModel)]="openIDConfigPopup.openIDMetadata">
				</div>
				<div class="align-items-center d-flex gap-2">
					<div class="col-4">
						<span>Client ID: </span>
					</div>
					<input style="width:350px; margin: 0;" type="text" [(ngModel)]="openIDConfigPopup.openIDClientId">
				</div>
				<div class="align-items-center d-flex gap-2">
					<div class="col-4">
						<span>Domains: </span>
					</div>
					<div class="flxRow hSpace2" style="align-items: center;">
						<input style="width:350px; margin: 0;" type="text" [(ngModel)]="openIDConfigPopup.openIDDomainsStr" placeholder="domains separated by comma">
						<i style="font-weight: 400; font-size: medium; position: relative;" class="far fa-question-circle"
						   tooltip="Only users from these domains will be able to log in using OIDC" placement="right"></i>
					</div>
				</div>
			</div>
		</div>
	</div>
</popup-c>

<!--Integration popup: SAML-->
<popup-c *ngIf="samlConfigPopup?.show"
		 head="Configure Integration with SAML" size="large" height="auto"
		 (closeCb)="samlConfigPopup = null;"
		 (confirmCb)="connectSamlExecute();"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Connect', loading: integrationActionInProcess}}">
	<div class="flxClmn">
		<span style="font-size: 16px;">Integrate your identity provider with {{gs.corpname}} using SAML by following the instructions below</span>
		<!--                    <span style="font-size: 16px; margin-left: 3px; color: cornflowerblue" class="">*</span>-->
		<br/><br/>
		<div class="list-group list-group-flush">
			<div class="list-group-item">
				<p style="line-height: 1.45rem; margin-block-end: 0;">
					1. Enter the inputs below in your identity provider's configuration:
				</p>
				<div style="align-items: center; margin:7px 15px;" class="flxRow-start hSpace2">
					Audience URI (Entity ID):
					<div style="font-size: 16px; width: 45%; background: #bac9d642; height: 30px; align-items: center;" class="flxClmn-center">
						<span style="font-weight:500; overflow: auto; width: 100%; text-align: center;" class="hide-scrollbar click-select-all">{{samlAudience}}</span>
					</div>
					<a (click)="copyText(samlAudience);">
						<i class="far fa-copy copy-link" tooltip="Copy Audience"></i>
					</a>
				</div>
				<div style="align-items: center; margin:7px 15px;" class="flxRow-start hSpace2">
					Reply URL (Assertion Consumer Service URL):
					<div style="font-size: 16px; width: 45%; background: #bac9d642; height: 30px; align-items: center;" class="flxClmn-center">
						<span style="font-weight:500; overflow: auto; width: 100%; text-align: center;" class="hide-scrollbar click-select-all">{{samlRedirectUrl}}</span>
					</div>
					<a (click)="copyText(samlRedirectUrl);">
						<i class="far fa-copy copy-link" tooltip="Copy URI"></i>
					</a>
				</div>
				<div style="align-items: center; margin:7px 15px;" class="flxRow-start hSpace2">
					Logout URL (Optional):
					<div style="font-size: 16px; width: 45%; background: #bac9d642; height: 30px; align-items: center;" class="flxClmn-center">
						<span style="font-weight:500; overflow: auto; width: 100%; text-align: center;" class="hide-scrollbar click-select-all">{{samlLogoutUrl}}</span>
					</div>
					<a (click)="copyText(samlLogoutUrl);">
						<i class="far fa-copy copy-link" tooltip="Copy URI"></i>
					</a>
				</div>
			</div>
			<div class="list-group-item">
				<p style="line-height: 1.45rem; margin: 0;">
					2. After the inputs above have been added, export/download the identity provider's metadata XML.
				</p>
			</div>
			<div class="list-group-item">
				<span>3. Upload the metadata XML below.</span>
				<div class="align-items-center d-flex gap-2" style="margin: 0.8rem 0;">
					<span style="line-height: 1;">Identity Provider Metadata XML: </span>
					<div class="link-btn" style="color: #4F77BC; cursor: pointer;"
					     accept="xml"
					     ngfSelect
					     (fileChange)="readSamlXml()"
					     [(file)]="samlConfigPopup.samlMetadataFile">
						Upload file
						<i class="far fa-file-upload"></i>
					</div>
					<span>{{samlConfigPopup.samlMetadataFile.name}}</span>
				</div>
			</div>
			<div class="list-group-item">
				<span>4. Enter your domains and click <b>Connect</b></span>
				<div class="align-items-center d-flex gap-2" style="margin: 0.8rem 0;">
					<span>Domains: </span>
					<div class="flxRow hSpace2" style="align-items: center;">
						<input style="width:350px; margin: 0;" type="text" [(ngModel)]="samlConfigPopup.samlDomainsStr" placeholder="domains separated by comma">
						<i style="font-weight: 400; font-size: medium; position: relative;" class="far fa-question-circle" placement="right"
						   tooltip="Only users from these domains will be able to log in using SAML"></i>
					</div>
				</div>
			</div>
		</div>
	</div>
</popup-c>

<!--Integration popup: Syslog-->
<popup-c *ngIf="syslogConnectPopup?.show" height="550px"
		 head="Connect to Syslog Server" size="dynamic"
		 subTitle="Enter the details below to set up your connection"
		 (closeCb)="syslogConnectPopup = null;"
		 (confirmCb)="connectSyslogExecute();"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Connect',
											 disabled: !syslogConnectPopup.host || !syslogConnectPopup.port,
											 loading: integrationActionInProcess}}">
	<div class="flxClmn">
		<span>Messages will be sent from static IPs (3.227.182.193, 54.161.96.109) when Syslog is connected to TCP protocol.</span>
		<br/>
		<br/>
		<table class="simpleDataTableShrink middle">
			<tr>
				<td><b>Host:&nbsp;</b></td>
				<td>
					<input style="width:100%; margin: 0;"
						   type="text"
						   [(ngModel)]="syslogConnectPopup.host">
				</td>
			</tr>
			<tr>
				<td><b>Port:&nbsp;</b></td>
				<td>
					<input style="width:100%; margin: 0;"
						   type="number"
						   [(ngModel)]="syslogConnectPopup.port">
				</td>
			</tr>
			<tr>
				<td><b>Protocol:&nbsp;</b></td>
				<td>
					<app-dropdown-c style="width:210px; max-height:150px; display:block; text-transform: uppercase;" [text]="syslogConnectPopup.protocol">
						<li *ngFor="let entry of syslogProtocols" style="text-transform: uppercase;"
							(click)="syslogConnectPopup.protocol = entry">{{ entry }}</li>
					</app-dropdown-c>
				</td>
			</tr>
		</table>
	</div>
</popup-c>

<!--Integration popup: Splunk-->
<popup-c *ngIf="splunkConnectPopup?.show"
		 head="Connect to Splunk Server" size="dynamic"
		 subTitle="Enter the details below to set up your connection"
		 (closeCb)="splunkConnectPopup = null;"
		 (confirmCb)="connectSplunkExecute();"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Connect',
											 disabled: !splunkConnectPopup.host || !splunkConnectPopup.token,
											 loading: integrationActionInProcess}}">
	<div class="flxClmn">
		<table class="simpleDataTableShrink middle">
			<tr>
				<td><b>Host:&nbsp;</b></td>
				<td>
					<input style="width:100%; margin: 0;"
						   type="text"
						   [(ngModel)]="splunkConnectPopup.host">
				</td>
			</tr>

			<tr>
				<td><b>Token:&nbsp;</b></td>
				<td>
					<input style="width:100%; margin: 0;"
						   type="text"
						   [(ngModel)]="splunkConnectPopup.token">
				</td>
			</tr>
		</table>
	</div>
</popup-c>

<!--Integration popup: QRadar-->
<!-- CC: taken from integrations.component.html -> Splunk connect popup -->
<popup-c *ngIf="qradarConnectPopup?.show"
		 head="Connect to QRadar Server" size="dynamic"
		 subTitle="Enter the details below to set up your connection"
		 (closeCb)="qradarConnectPopup = null;"
		 (confirmCb)="connectQradarExecute();"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Connect',
											 disabled: !qradarConnectPopup.host || !qradarConnectPopup.token,
											 loading: integrationActionInProcess}}">
	<div class="flxClmn">
		<table class="simpleDataTableShrink middle">
			<tr>
				<td><b>Host:&nbsp;</b></td>
				<td>
					<input style="width:100%; margin: 0;"
						   type="text"
						   [(ngModel)]="qradarConnectPopup.host">
				</td>
			</tr>

			<tr>
				<td><b>Token:&nbsp;</b></td>
				<td>
					<input style="width:100%; margin: 0;"
						   type="text"
						   [(ngModel)]="qradarConnectPopup.token">
				</td>
			</tr>
		</table>
	</div>
</popup-c>

<!--Integration popup: Graylog-->
<!-- CC: taken from integrations.component.html -> QRadar connect popup -->
<popup-c *ngIf="graylogConnectPopup?.show"
		 head="Connect to Graylog Server" size="dynamic"
		 subTitle="Enter the details below to set up your connection"
		 (closeCb)="graylogConnectPopup = null;"
		 (confirmCb)="connectGraylogExecute();"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Connect',
											 disabled: !graylogConnectPopup.host || !graylogConnectPopup.port,
											 loading: integrationActionInProcess}}">
	<div class="flxClmn" style="gap: 12px;">
		<p style="margin: 0; line-height: 1.5;">
			To connect Graylog, set up a GELF HTTP input to receive the logs.<br/><br/>

			Go to <strong>Graylog</strong> <span style="margin: 0 2px; color: lightslategrey;">❯</span>
			<strong>System</strong> <span style="margin: 0 2px; color: lightslategrey;">❯</span>
			<strong>Inputs</strong>, select <strong>GELF HTTP</strong> and click <strong>Launch new input</strong>.
			Set the bind address and port (default <code>12201</code>) and save.
			Make sure the input is reachable from the internet over HTTPS.
			See the <a style="color: cornflowerblue; font-weight: bold;"
					   href="https://go2docs.graylog.org/current/getting_in_log_data/gelf.html"
					   target="_blank" rel="noopener noreferrer">GELF input guide</a> for details.
		</p>

		<table class="simpleDataTableShrink middle">
			<tr>
				<td style="width: 85px;"><b>Host URL:&nbsp;</b></td>
				<td>
					<input style="width:100%; margin: 0;"
						   type="text"
						   placeholder="https://logs.company.com"
						   [(ngModel)]="graylogConnectPopup.host">
					<small style="color: grey;">The public address of your Graylog server, e.g. https://logs.company.com. Graylog doesn't display its public address, so get it from your Graylog administrator or cloud provider</small>
				</td>
			</tr>

			<tr>
				<td><b>Port:&nbsp;</b></td>
				<td>
					<input style="width:100%; margin: 0;"
						   type="number"
						   [(ngModel)]="graylogConnectPopup.port">
					<small style="color: grey;">The port your GELF HTTP input listens on. Find it under System <span style="margin: 0 2px;">❯</span> Inputs, in the port value shown on your GELF HTTP input (default 12201)</small>
				</td>
			</tr>

			<tr>
				<td><b>Token:&nbsp;</b></td>
				<td>
					<input style="width:100%; margin: 0;"
						   type="text"
						   [(ngModel)]="graylogConnectPopup.token">
					<small style="color: grey;">In System <span style="margin: 0 2px;">❯</span> Inputs <span style="margin: 0 2px;">❯</span> your GELF HTTP input <span style="margin: 0 2px;">❯</span> Edit input, set <b>Authorization Header Name</b> to <b>Authorization</b> and copy the exact <b>Authorization Header Value</b> here. Leave blank if authentication is disabled</small>
				</td>
			</tr>
		</table>
	</div>
</popup-c>

<!--Integration popup: SentinelOne-->
<popup-c *ngIf="sentinelOneConnectPopup?.show"
		 head="Connect to SentinelOne Server" size="dynamic"
		 subTitle="Enter the details below to set up your connection"
		 (closeCb)="sentinelOneConnectPopup = null;"
		 (confirmCb)="connectSentinelOneExecute();"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Connect',
											 disabled: !sentinelOneConnectPopup.host || !sentinelOneConnectPopup.token,
											 loading: integrationActionInProcess}}">
	<div class="flxClmn" style="gap: 12px;">
		<p style="margin: 0; line-height: 1.5;">
			To connect SentinelOne, you need your management console URL and an API token.<br/>
			Go to <strong>SentinelOne Console</strong> <span style="margin: 0 2px; color: lightslategrey;">❯</span>
			<strong>Settings</strong> <span style="margin: 0 2px; color: lightslategrey;">❯</span>
			<strong>Users</strong>, select your user, and generate an API token under <strong>Options</strong> <span style="margin: 0 2px; color: lightslategrey;">❯</span>
			<strong>API Token</strong>.
		</p>

		<table class="simpleDataTableShrink middle">
			<tr>
				<td><b>Host:&nbsp;</b></td>
				<td>
					<input style="width:100%; margin: 0;"
						   type="text"
						   placeholder="https://xdr.<region>.sentinelone.net"
						   [(ngModel)]="sentinelOneConnectPopup.host">
					<small style="color: grey;">Your SentinelOne management console URL</small>
				</td>
			</tr>

			<tr>
				<td><b>Token:&nbsp;</b></td>
				<td>
					<input style="width:100%; margin: 0;"
						   type="text"
						   [(ngModel)]="sentinelOneConnectPopup.token">
					<small style="color: grey;">Generated under Settings <span style="margin: 0 2px;">❯</span> Users <span style="margin: 0 2px;">❯</span> your user <span style="margin: 0 2px;">❯</span> Options <span style="margin: 0 2px;">❯</span> API Token</small>
				</td>
			</tr>
		</table>
	</div>
</popup-c>

<!--Integration popup: Sumo Logic-->
<popup-c *ngIf="sumoLogicConnectPopup?.show"
		 head="Connect to Sumo Logic Server" size="dynamic"
		 subTitle="Enter the details below to set up your connection"
		 (closeCb)="sumoLogicConnectPopup = null;"
		 (confirmCb)="connectSumoLogicExecute();"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Connect',
											 disabled: !sumoLogicConnectPopup.http_host,
											 loading: integrationActionInProcess}}">
	<div class="flxClmn">
		<div>
			In your Sumo Logic account, create a new collector and add a source of type 'HTTP Logs & Metrics'.<br/>
			Then, copy the generated HTTP Source URL below so Trustifi can send logs to it.
		</div>
		<br/>
		<table class="simpleDataTableShrink middle">
			<tr>
				<td><b>HTTP Source Address:&nbsp;</b></td>
				<td>
					<input style="width: 200px;"
						   type="text"
						   [(ngModel)]="sumoLogicConnectPopup.http_host">
				</td>
			</tr>
		</table>
	</div>
</popup-c>

<!--Integration popup: Rapid7-->
<popup-c *ngIf="rapid7ConnectPopup?.show"
		 head="Connect to Rapid7 Server" size="dynamic"
		 subTitle="Enter the details below to set up your connection"
		 (closeCb)="rapid7ConnectPopup = null;"
		 (confirmCb)="connectRapid7Execute();"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Connect',
											 disabled: !rapid7ConnectPopup.host,
											 loading: integrationActionInProcess}}">
	<div class="flxClmn">
		<div>
			In your Rapid7 account, create a new custom event source and add choose run on Webhook.<br/>
			Then, copy the generated webhook URL below so Trustifi can send logs to it.
		</div>
		<br/>
		<table class="simpleDataTableShrink middle">
			<tr>
				<td><b>Webhook URL:&nbsp;</b></td>
				<td>
					<input style="width: 200px;"
						   type="text"
						   [(ngModel)]="rapid7ConnectPopup.host">
				</td>
			</tr>
		</table>
	</div>
</popup-c>

<!--Integration popup: CrowdStrike-->
<popup-c *ngIf="crowdStrikeConnectPopup?.show"
		 head="Connect to CrowdStrike Server" size="dynamic"
		 subTitle="Enter the details below to set up your connection"
		 (closeCb)="crowdStrikeConnectPopup = null;"
		 (confirmCb)="connectCrowdStrikeExecute();"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Connect',
											 disabled: !crowdStrikeConnectPopup.host,
											 loading: integrationActionInProcess}}">
	<div class="flxClmn">
		<table class="simpleDataTableShrink middle">
			<tr>
				<td><b>Host:&nbsp;</b></td>
				<td>
					<input style="width:100%; margin: 0;"
						   type="text"
						   placeholder="https://<your-tenant>.ingest.<region>.crowdstrike.com"
						   [(ngModel)]="crowdStrikeConnectPopup.host">
				</td>
			</tr>

			<tr>
				<td><b>Token:&nbsp;</b></td>
				<td>
					<input style="width:100%; margin: 0;"
						   type="text"
						   [(ngModel)]="crowdStrikeConnectPopup.token">
				</td>
			</tr>
		</table>
	</div>
</popup-c>

<!--Integration popup: Huntress-->
<popup-c *ngIf="huntersConnectPopup?.show"
		 head="Connect to Huntress Server" size="dynamic"
		 subTitle="Enter the details below to set up your connection"
		 (closeCb)="huntersConnectPopup = null;"
		 (confirmCb)="connectToHuntersExecute();"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Connect',
											 disabled: !huntersConnectPopup.token,
											 loading: integrationActionInProcess}}">
	<div class="flxClmn">
		<table class="simpleDataTableShrink middle">
			<tr>
				<td><b>Token:&nbsp;</b></td>
				<td>
					<input style="width:100%; margin: 0;"
						   type="text"
						   [(ngModel)]="huntersConnectPopup.token">
				</td>
			</tr>
		</table>
	</div>
</popup-c>

<!--Integration popup: Halo PSA-->
<popup-c *ngIf="haloPSAConnectPopup?.show"
		 head="Connect to Halo PSA Server" size="dynamic"
		 subTitle="Enter the details below to set up your connection"
		 (closeCb)="haloPSAConnectPopup = null;"
		 (confirmCb)="connectToHaloPsaExecute();"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Connect',
											 loading: integrationActionInProcess}}">
	<div class="flxClmn" style="gap: 12px;">
		<!-- CC: explanation block pattern taken from ~line 1131 (Google Workspace popup) -->
		<p style="margin: 0; line-height: 1.5;">
			To connect Halo PSA, you'll need to create an API application in your Halo PSA instance.<br/>
			Go to <strong>Configuration</strong> <span style="margin: 0 2px; color: lightslategrey;">❯</span>
			<strong>HaloPSA API</strong> and create a new application with
			<strong>Client Credentials</strong> authentication.
			See the <a style="color: cornflowerblue; font-weight: bold;"
					   href="https://usehalo.com/halopsa/guides/1823"
					   target="_blank" rel="noopener noreferrer">Halo PSA API guide</a> for details.<br/><br/>
			The following permissions must be granted to the API application:<br/>
			<code>read:customers</code>&nbsp;&nbsp;<code>read:tickets</code>&nbsp;&nbsp;<code>edit:tickets</code>&nbsp;&nbsp;<code>all:teams</code>
		</p>

		<table class="simpleDataTableShrink middle">
			<tr>
				<td><b>Tenant:</b></td>
				<td>
					<input style="width:100%; margin: 0;"
						   type="text"
						   placeholder="e.g. yourcompany"
						   [(ngModel)]="haloPSAConnectPopup.tenant">
					<small style="color: grey;">Your Halo PSA subdomain (the part before .usehalo.com)</small>
				</td>
			</tr>

			<!-- CC: added Resource Domain field -->
			<tr>
				<td><b>Resource Domain:</b></td>
				<td>
					<input style="width:100%; margin: 0;"
						   type="text"
						   [(ngModel)]="haloPSAConnectPopup.resource_domain">
					<small style="color: grey;">The Halo PSA resource domain</small>
				</td>
			</tr>

			<tr>
				<td><b>Client ID:</b></td>
				<td>
					<input style="width:100%; margin: 0;"
						   type="text"
						   [(ngModel)]="haloPSAConnectPopup.client_id">
					<small style="color: grey;">Found in your Halo PSA API application settings</small>
				</td>
			</tr>

			<tr>
				<td><b>Client Secret:</b></td>
				<td>
					<input style="width:100%; margin: 0;"
						   type="text"
						   [(ngModel)]="haloPSAConnectPopup.client_secret">
					<small style="color: grey;">Generated when creating or editing the API application</small>
				</td>
			</tr>

			<tr>
				<td><b>Ticket Category:</b></td>
				<td>
					<input style="width:100%; margin: 0;"
						   type="text"
						   placeholder="Optional"
						   [(ngModel)]="haloPSAConnectPopup.category">
					<small style="color: grey;">The category ID to assign to tickets created from email threats</small>
				</td>
			</tr>

			<tr>
				<td><b>Ticket Type:</b></td>
				<td>
					<input style="width:100%; margin: 0;"
						   type="text"
						   placeholder="Optional"
						   [(ngModel)]="haloPSAConnectPopup.ticketType">
					<small style="color: grey;">Optional ticket type ID (leave blank to use the default)</small>
				</td>
			</tr>
		</table>
	</div>
</popup-c>

<!--Integration popup: ConnectWise-->
<popup-c *ngIf="connectWiseConnectPopup?.show"
		 head="Connect to ConnectWise Server" size="dynamic"
		 subTitle="Enter the details below to set up your connection"
		 (closeCb)="connectWiseConnectPopup = null;"
		 (confirmCb)="connectToConnectWiseExecute();"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Connect',
											 loading: integrationActionInProcess}}">
	<div class="flxClmn">
		<table class="simpleDataTableShrink middle">
			<tr>
				<td><b>Tenant:</b></td>
				<td>
					<input style="width:100%; margin: 0;"
						   type="text"
						   [(ngModel)]="connectWiseConnectPopup.tenant">
				</td>
			</tr>

			<tr>
				<td><b>Client ID:</b></td>
				<td>
					<input style="width:100%; margin: 0;"
						   type="text"
						   [(ngModel)]="connectWiseConnectPopup.client_id">
				</td>
			</tr>

			<tr>
				<td><b>Client Secret:</b></td>
				<td>
					<input style="width:100%; margin: 0;"
						   type="text"
						   [(ngModel)]="connectWiseConnectPopup.client_secret">
				</td>
			</tr>

			<tr>
				<td><b>Authorization Server:</b></td>
				<td>
					<input style="width:100%; margin: 0;"
						   type="text"
						   [(ngModel)]="connectWiseConnectPopup.auth_server">
				</td>
			</tr>

			<tr>
				<td><b>Resource Server:</b></td>
				<td>
					<input style="width:100%; margin: 0;"
						   type="text"
						   [(ngModel)]="connectWiseConnectPopup.resource_server">
				</td>
			</tr>

			<tr>
				<td><b>Ticket Category:</b></td>
				<td>
					<input style="width:100%; margin: 0;"
						   type="text"
						   [(ngModel)]="connectWiseConnectPopup.category">
				</td>
			</tr>

			<tr>
				<td><b>Ticket Type:</b></td>
				<td>
					<input style="width:100%; margin: 0;"
						   type="text"
						   placeholder="Optional"
						   [(ngModel)]="connectWiseConnectPopup.ticketType">
				</td>
			</tr>
		</table>
	</div>
</popup-c>

<!--Integration popup: Autotask-->
<!-- CC: taken from integrations.component.html -> HaloPSA connect popup -->
<popup-c *ngIf="autotaskConnectPopup?.show"
		 head="Connect to Autotask Server" size="dynamic"
		 subTitle="Enter the details below to set up your connection"
		 (closeCb)="autotaskConnectPopup = null;"
		 (confirmCb)="connectToAutotaskExecute();"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Connect',
											 loading: integrationActionInProcess}}">
	<div class="flxClmn" style="gap: 12px;">
		<p style="margin: 0; line-height: 1.5;">
			To connect Autotask, you need to create an API user in your Autotask instance.<br/>
			Go to <strong>Admin</strong> <span style="margin: 0 2px; color: lightslategrey;">❯</span>
			<strong>Resources (Users)</strong> <span style="margin: 0 2px; color: lightslategrey;">❯</span>
			<strong>Resources/Users (HR)</strong> and create a new API user.
			See the <a style="color: cornflowerblue; font-weight: bold;"
					   href="https://www.autotask.net/help/developerhelp/Content/APIs/REST/API_Calls/REST_ZoneInformation.htm"
					   target="_blank" rel="noopener noreferrer">Autotask REST API Authentication guide</a> for details.
		</p>

		<table class="simpleDataTableShrink middle">
			<tr>
				<td><b>Username:</b></td>
				<td>
					<input style="width:100%; margin: 0;"
						   type="text"
						   [(ngModel)]="autotaskConnectPopup.username">
					<small style="color: grey;">The API user username (email address)</small>
				</td>
			</tr>

			<tr>
				<td><b>Secret:</b></td>
				<td>
					<input style="width:100%; margin: 0;"
						   type="text"
						   [(ngModel)]="autotaskConnectPopup.secret">
					<small style="color: grey;">The API user secret key, generated when creating the API user</small>
				</td>
			</tr>

			<tr>
				<td><b>Integration Code:</b></td>
				<td>
					<input style="width:100%; margin: 0;"
						   type="text"
						   [(ngModel)]="autotaskConnectPopup.integration_code">
					<small style="color: grey;">Found under Admin <span style="margin: 0 2px;">❯</span> Extensions & Integrations <span style="margin: 0 2px;">❯</span> Other Extensions & Tools</small>
				</td>
			</tr>

			<tr>
				<td><b>Company ID:</b></td>
				<td>
					<input style="width:100%; margin: 0;"
						   type="number"
						   [(ngModel)]="autotaskConnectPopup.company_id">
					<small style="color: grey;">Your Autotask company ID (found in the URL or company record)</small>
				</td>
			</tr>

			<tr>
				<td><b>Queue ID:</b></td>
				<td>
					<input style="width:100%; margin: 0;"
						   type="number"
						   [(ngModel)]="autotaskConnectPopup.queue_id">
					<small style="color: grey;">The service desk queue ID for ticket routing</small>
				</td>
			</tr>
		</table>
	</div>
</popup-c>

<!--Integration popup: SuperOps-->
<!-- CC: taken from integrations.component.html -> Autotask connect popup -->
<popup-c *ngIf="superOpsConnectPopup?.show"
		 head="Connect to SuperOps Server" size="dynamic"
		 subTitle="Enter the details below to set up your connection"
		 (closeCb)="superOpsConnectPopup = null;"
		 (confirmCb)="connectToSuperOpsExecute();"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Connect',
												 loading: integrationActionInProcess}}">
	<div class="flxClmn" style="gap: 12px;">
		<p style="margin: 0; line-height: 1.5;">
			To connect SuperOps, you'll need to create an API application in your SuperOps instance.<br/>
			Go to <strong>Settings</strong> <span style="margin: 0 2px; color: lightslategrey;">❯</span>
			<strong>Developer Space</strong> and create a new API client.
		</p>

		<table class="simpleDataTableShrink middle">
			<tr>
				<td><b>Subdomain:</b></td>
				<td>
					<input style="width:100%; margin: 0;"
						   type="text"
						   [(ngModel)]="superOpsConnectPopup.subdomain">
					<small style="color: grey;">Your SuperOps subdomain (the part before .superops.com)</small>
				</td>
			</tr>

			<tr>
				<td><b>API Token:</b></td>
				<td>
					<input style="width:100%; margin: 0;"
						   type="text"
						   [(ngModel)]="superOpsConnectPopup.api_token">
					<small style="color: grey;">Your SuperOps API token</small>
				</td>
			</tr>

			<tr>
				<td><b>Data Center:</b></td>
				<td>
					<app-dropdown-c style="width: 100%;" [text]="superOpsConnectPopup.data_center === 'eu' ? 'EU' : 'US'">
						<li (click)="superOpsConnectPopup.data_center = 'us'">US</li>
						<li (click)="superOpsConnectPopup.data_center = 'eu'">EU</li>
					</app-dropdown-c>
				</td>
			</tr>
		</table>
	</div>
</popup-c>

<!--Integration popup: XSIAM-->
<popup-c *ngIf="xsiamConnectPopup?.show"
		 head="Connect to Cortex XSIAM Server" size="dynamic"
		 subTitle="Enter the details below to set up your connection"
		 (closeCb)="xsiamConnectPopup = null;"
		 (confirmCb)="connectXsiamExecute();"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Connect',
											 disabled: !xsiamConnectPopup.host || !xsiamConnectPopup.token,
											 loading: integrationActionInProcess}}">
	<div class="flxClmn">
		<table class="simpleDataTableShrink middle">
			<tr>
				<td><b>Host:</b></td>
				<td>
					<input style="width:100%; margin: 0;"
						   type="text"
						   placeholder="https://api-{your-region}.xsiam.paloaltonetworks.com"
						   [(ngModel)]="xsiamConnectPopup.host">
				</td>
			</tr>

			<tr>
				<td><b>Token:</b></td>
				<td>
					<input style="width:100%; margin: 0;"
						   type="text"
						   [(ngModel)]="xsiamConnectPopup.token">
				</td>
			</tr>
		</table>
	</div>
</popup-c>

<!--Integration popup: Azure EventHub-->
<popup-c *ngIf="azureEventHubConnectPopup?.show"
		 head="Connect to Azure EventHub Server" size="dynamic"
		 subTitle="Enter the details below to set up your connection"
		 (closeCb)="azureEventHubConnectPopup = null;"
		 (confirmCb)="connectToAzureEventHubExecute();"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Connect', disabled: !azureEventHubConnectPopup.connection, loading: integrationActionInProcess}}">
	<div class="flxClmn gap-2">
		<span>Paste your Azure connection string:</span>
		<input style="width:100%; margin: 0;" placeholder="Endpoint=..." type="text" [(ngModel)]="azureEventHubConnectPopup.connection">
	</div>
</popup-c>

<!--Integration popup: Microsoft Sentinel-->
<!-- CC: taken from integrations.component.html -> HaloPSA popup -->
<popup-c *ngIf="microsoftSentinelConnectPopup?.show"
		 head="Connect to Microsoft Sentinel" size="dynamic"
		 subTitle="Enter the details below to set up your connection"
		 (closeCb)="microsoftSentinelConnectPopup = null;"
		 (confirmCb)="connectMicrosoftSentinelExecute();"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Connect',
											 disabled: !microsoftSentinelConnectPopup.host || !microsoftSentinelConnectPopup.tenant_id || !microsoftSentinelConnectPopup.client_id || !microsoftSentinelConnectPopup.client_secret,
											 loading: integrationActionInProcess}}">
	<div class="flxClmn" style="gap: 12px;">
		<p style="margin: 0; line-height: 1.5;">
			To connect Microsoft Sentinel, set up a Data Collection Endpoint, a custom table with its Data Collection Rule, and an App Registration in your Azure portal.<br/><br/>

			<b>1.</b> Go to <strong>Azure Portal</strong> <span style="margin: 0 2px; color: lightslategrey;">❯</span>
			<strong>Monitor</strong> <span style="margin: 0 2px; color: lightslategrey;">❯</span>
			<strong>Data Collection Endpoints</strong> and create a new endpoint.<br/>

			<b>2.</b> Go to your Sentinel <strong>Log Analytics workspace</strong> <span style="margin: 0 2px; color: lightslategrey;">❯</span>
			<strong>Tables</strong> <span style="margin: 0 2px; color: lightslategrey;">❯</span>
			<strong>Create</strong> <span style="margin: 0 2px; color: lightslategrey;">❯</span>
			<strong>New custom log (DCR-based)</strong>. Select the endpoint from step 1 and create a new Data Collection Rule.
			When asked for sample data, use a JSON file with these columns:
			<code>TimeGenerated</code> (datetime), <code>name</code>, <code>description</code>, <code>identity</code> (string), <code>data</code> (dynamic).
			See the <a style="color: cornflowerblue; font-weight: bold;"
			           href="https://learn.microsoft.com/en-us/azure/azure-monitor/logs/tutorial-logs-ingestion-portal"
			           target="_blank" rel="noopener noreferrer">Azure Monitor Ingestion guide</a> for details.<br/>

			<b>3.</b> Register an app under <strong>Microsoft Entra ID</strong> <span style="margin: 0 2px; color: lightslategrey;">❯</span>
			<strong>App registrations</strong> and assign it the <strong>Monitoring Metrics Publisher</strong> role on the Data Collection Rule
			(it may take up to 30 minutes to take effect).
			See the <a style="color: cornflowerblue; font-weight: bold;"
			           href="https://learn.microsoft.com/en-us/entra/identity-platform/quickstart-register-app"
			           target="_blank" rel="noopener noreferrer">App Registration guide</a> for details.
		</p>

		<table class="simpleDataTableShrink middle">
			<tr>
				<td><b>Ingestion URL:</b></td>
				<td>
					<input style="width:100%; margin: 0;"
					       type="text"
					       placeholder="https://<dce-name>.<region>.ingest.monitor.azure.com"
					       [(ngModel)]="microsoftSentinelConnectPopup.host">
					<small style="color: grey;">Found in your Data Collection Endpoint overview under Logs Ingestion</small>
				</td>
			</tr>

			<tr>
				<td><b>DCR Immutable ID:</b></td>
				<td>
					<input style="width:100%; margin: 0;"
					       type="text"
					       placeholder="dcr-xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx"
					       [(ngModel)]="microsoftSentinelConnectPopup.dcr_id">
					<small style="color: grey;">Found in your Data Collection Rule <span style="margin: 0 2px;">❯</span> Overview <span style="margin: 0 2px;">❯</span> Immutable ID</small>
				</td>
			</tr>

			<tr>
				<td><b>Stream Name:</b></td>
				<td>
					<input style="width:100%; margin: 0;"
					       type="text"
					       placeholder="Custom-<TableName>_CL"
					       [(ngModel)]="microsoftSentinelConnectPopup.stream_name">
					<small style="color: grey;">Found in your Data Collection Rule <span style="margin: 0 2px;">❯</span> JSON View <span style="margin: 0 2px;">❯</span> streamDeclarations</small>
				</td>
			</tr>

			<tr>
				<td><b>Tenant ID:</b></td>
				<td>
					<input style="width:100%; margin: 0;"
					       type="text"
					       [(ngModel)]="microsoftSentinelConnectPopup.tenant_id">
					<small style="color: grey;">Found in Microsoft Entra ID <span style="margin: 0 2px;">❯</span> Overview <span style="margin: 0 2px;">❯</span> Tenant ID</small>
				</td>
			</tr>

			<tr>
				<td><b>Client ID:</b></td>
				<td>
					<input style="width:100%; margin: 0;"
					       type="text"
					       [(ngModel)]="microsoftSentinelConnectPopup.client_id">
					<small style="color: grey;">Found in your App Registration overview (Application ID)</small>
				</td>
			</tr>

			<tr>
				<td><b>Client Secret:</b></td>
				<td>
					<input style="width:100%; margin: 0;"
					       type="password"
					       autocomplete="new-password"
					       [(ngModel)]="microsoftSentinelConnectPopup.client_secret">
					<small style="color: grey;">Generated under App Registration <span style="margin: 0 2px;">❯</span> Certificates & secrets (note its expiry date)</small>
				</td>
			</tr>
		</table>
	</div>
</popup-c>

<!--Integration popup: Stellar Cyber-->
<!-- CC: taken from integrations.component.html -> CrowdStrike popup -->
<popup-c *ngIf="stellarCyberConnectPopup?.show"
		 head="Connect to Stellar Cyber Server" size="dynamic"
		 subTitle="Enter the details below to set up your connection"
		 (closeCb)="stellarCyberConnectPopup = null;"
		 (confirmCb)="connectStellarCyberExecute();"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Connect',
											 disabled: !stellarCyberConnectPopup.host,
											 loading: integrationActionInProcess}}">
	<div class="flxClmn">
		<table class="simpleDataTableShrink middle">
			<tr>
				<td><b>Host:&nbsp;</b></td>
				<td>
					<input style="width:100%; margin: 0;"
						   type="text"
						   placeholder="https://<your-tenant>.stellarcyber.ai"
						   [(ngModel)]="stellarCyberConnectPopup.host">
				</td>
			</tr>

			<tr>
				<td><b>Username:&nbsp;</b></td>
				<td>
					<input style="width:100%; margin: 0;"
						   type="text"
						   placeholder="Optional"
						   [(ngModel)]="stellarCyberConnectPopup.username">
				</td>
			</tr>

			<tr>
				<td><b>API Key:&nbsp;</b></td>
				<td>
					<input style="width:100%; margin: 0;"
						   type="text"
						   [(ngModel)]="stellarCyberConnectPopup.api_key">
					<small style="color: grey;">Use a scoped API key: in Stellar Cyber, go to User Profile <span style="margin: 0 2px;">❯</span> API Keys <span style="margin: 0 2px;">❯</span> Create API Key. The user must be a local account, not SSO.</small>
				</td>
			</tr>
		</table>
	</div>
</popup-c>

<!--Integration popup: CheckPoint-->
<popup-c *ngIf="checkpointConnectPopup?.show"
		 head="Connect to Check Point" size="dynamic"
		 (closeCb)="checkpointConnectPopup = null;"
		 (confirmCb)="connectCheckpointExecute();"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Connect',
											 disabled: !checkpointConnectPopup.checkpointAccessKey || !checkpointConnectPopup.checkpointClientID,
											 loading: integrationActionInProcess}}">
	<div class="flxClmn vSpace2">
		<span>Enter the following information in order to connect {{gs.corpname}} with Check Point Harmony Threat Hunting</span>
		<table class="simpleDataTableShrink middle">
			<tr>
				<td><b>Client ID:&nbsp;</b></td>
				<td>
					<input style="width: 100%; margin: 0;"
						   type="text"
						   [(ngModel)]="checkpointConnectPopup.checkpointClientID">
				</td>
			</tr>
			<tr>
				<td><b>Access Key:&nbsp;</b></td>
				<td>
					<input style="width: 100%; margin: 0;"
						   type="text"
						   [(ngModel)]="checkpointConnectPopup.checkpointAccessKey">
				</td>
			</tr>
		</table>
	</div>
</popup-c>

<!--Integration popup: Amazon S3-->
<popup-c *ngIf="S3ConnectPopup?.show"
		 head="Connect to Amazon S3" size="dynamic"
		 subTitle="Enter the details below to set up your connection"
		 (closeCb)="S3ConnectPopup = null;"
		 (confirmCb)="connectS3Execute();"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Connect',
											 disabled: !validateS3(),
											 loading: integrationActionInProcess}}">
	<div class="flxClmn">
		<div class="vSpace05" style="line-height: 1.6;">
			<span>To integrate Trustifi with your own {{gs.corpname}} S3 buckets you need to:</span>
			<ol>
				<li>Create 4 buckets with no public access and enable SSE encryption</li>
				<li>Delegate access to our AWS account: <b>775278833801</b>. <br/>(you can follow the first step from this guide:
					<a href="https://docs.aws.amazon.com/IAM/latest/UserGuide/tutorial_cross-account-with-roles.html" target="_blank" rel="tutorial-cross-account-with-role">tutorial-cross-account-with-role</a>)</li>
				<li>Enter the relevant information here</li>
			</ol>
		</div>
		<br/><br/>
		<table class="simpleDataTableShrink middle">
			<tr>
				<td style="width: 175px;"><b>Remote Account ID:&nbsp;</b></td>
				<td>
					<input type="text" style="width:100%; margin: 0;" [(ngModel)]="S3ConnectPopup.remote_account_id">
				</td>
			</tr>
			<tr>
				<td><b>Remote Role:&nbsp;</b></td>
				<td>
					<input type="text" style="width:100%; margin: 0;" [(ngModel)]="S3ConnectPopup.remote_role">
				</td>
			</tr>
			<tr>
				<td><b>Use your own server-side encryption:&nbsp;</b></td>
				<td><checkbox id="use_predefined_sse" [(model)]="S3ConnectPopup.use_predefined_sse"></checkbox></td>
			</tr>
			<tr>
				<td><b>Attachments Bucket:&nbsp;</b></td>
				<td><input type="text" style="width:100%; margin: 0;" [(ngModel)]="S3ConnectPopup.attachments"/></td>
			</tr>
			<tr>
				<td><b>Content Bucket:&nbsp;</b></td>
				<td><input type="text" style="width:100%; margin: 0;" [(ngModel)]="S3ConnectPopup.content"/></td>
			</tr>
			<tr>
				<td><b>Quarantined Bucket:&nbsp;</b></td>
				<td><input type="text" style="width:100%; margin: 0;" [(ngModel)]="S3ConnectPopup.quarantinedEmail"/></td>
			</tr>
			<tr>
				<td><b>Archiving Bucket:&nbsp;</b></td>
				<td><input type="text" style="width:100%; margin: 0;" [(ngModel)]="S3ConnectPopup.archiving"/></td>
			</tr>
		</table>
	</div>
</popup-c>

<popup-c class="bs-enabled" *ngIf="changeEndPointPopup?.show"
		 head="Change cloud API endpoint" size="dynamic"
		 (closeCb)="changeEndPointPopup.show = false;"
		 (confirmCb)="changeEndPointPopup?.doneCb()"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Change', disabled: changeEndPointPopup.applyInProcess}}">
	<div class="flex-column f-1-0 gap-2" style="overflow: auto;">
		<div class="d-flex gap-1 text-danger pt-2" style="font-size: 14px;">
			<i class="zmdi zmdi-alert-circle-o" style="font-size: 1.5rem; margin-top: -6px;"></i>
			{{changeEndPointPopup.subTitle}}
		</div>

		<ul>
			<li>Make sure you have selected the correct endpoint. Selecting an incorrect endpoint can cause communication failures with the cloud API.</li>
		</ul>

		<!--will show only when selecting exchangeServerEndpoints.Hybrid-->
		<div class="align-items-center flex-row gap-3" *ngIf="changeEndPointPopup.azureADInput !== undefined">
			<div style="min-width: 120px;">Azure AD</div>
			<input type="text" placeholder="Azure AD endpoint"
				   style="width:330px;" [required]="true"
				   [(ngModel)]="changeEndPointPopup.azureADInput"/>
		</div>
		<div class="align-items-center flex-row gap-3" *ngIf="changeEndPointPopup.microsoftGraphAPIInput !== undefined">
			<div style="min-width: 120px;">Microsoft Graph API</div>
			<input type="text" placeholder="Microsoft Graph API endpoint"
				   style="width:330px;" [required]="true"
				   [(ngModel)]="changeEndPointPopup.microsoftGraphAPIInput"/>
		</div>
		<div class="align-items-center flex-row gap-3" *ngIf="changeEndPointPopup.axoAdminAPIInput !== undefined">
			<div style="min-width: 120px;">Powershell API</div>
			<input type="text" placeholder="Powershell API endpoint"
				   style="width:330px;" [required]="true"
				   [(ngModel)]="changeEndPointPopup.axoAdminAPIInput"/>
		</div>
	</div>
</popup-c>


<popup-c class="bs-enabled" *ngIf="webHooksUsersPopup?.show"
		 head="Select Users for Webhooks" size="medium"
		 (closeCb)="webHooksUsersPopup.show = false;"
		 (confirmCb)="webHooksUsersPopup.doneCb()"
		 [buttons]="{cancel: 'Cancel', confirm: 'Confirm'}">
	<div class="flxClmn gap-3 f-1-0" style="overflow: auto;">
		<span>Select one or more users to get events information for:</span>
		<div class="flxClmn f-1-0 gap-2" style="overflow: auto;">
			<label class="radio-container m-0" style="display: block;">
				All users
				<input type="radio"
					   [(ngModel)]="webHooksUsersPopup.type"
					   [value]="'all'">
				<span class="checkmark"></span>
			</label>
			<div class="flex-row gap-1 align-items-center">
				<label class="radio-container m-0" style="display: block; width: fit-content;">
					Specific users:
					<input type="radio"
						   [(ngModel)]="webHooksUsersPopup.type"
						   [value]="'specific'">
					<span class="checkmark"></span>
				</label>
			</div>
			<div class="position-relative f-1-0 flex-column overflow-auto">
				<!--table overlay when disabled-->
				<div class="w-100 h-100" style="background-color: white; position: absolute; top: 0; left: 0; z-index: 20; opacity: 0.4;"
					 *ngIf="webHooksUsersPopup.type === 'all'">
				</div>
				<trustifi-table-c
					class="trustifi-table f-1-0" style="z-index: 5;"
					[list]="webHooksUsersPopup.users"
					[cellsPrototype]="[
					  {textKey: 'email'},
				  ]"
					(searchFunction)="searchUser($event.searchTerm)"
					[options]="{
						itemsNameSingular: 'user',
						loadingTableFlag: webHooksUsersPopup.loadingUsers,
						showRadioButtons: true,
						noHeader: true
					}"
				>
				</trustifi-table-c>
			</div>
		</div>
	</div>
</popup-c>
